import PropTypes from 'prop-types';
import InspirationSlider from '../InspirationSlider';

export default class InspirationCard extends React.Component {
    static propTypes = {
        inspirationId: PropTypes.number,
        name: PropTypes.string,
        description: PropTypes.string,
        images: PropTypes.object
    };
    static defaultProps = {

    };
    constructor() {
        super();
    }

    _imagesSetBarAnimation = () => {
        return (e) => {
            const $el = $(e.target);
            const $allOptions = $el.closest('.wedding-stage').find('.option');

            $allOptions.removeClass('active');
            $el.addClass('active');
        };
    };

    render() {
        const { inspirationId, name, description, images } = this.props;
        const receptionArray = images.homeReception;
        const ceremonyArray = images.homeCeremony;
        const currentInspiration = {};
        const hashInspirationName = name.split(' ').join('');

        currentInspiration.name = name;
        currentInspiration.id = inspirationId;


        return (
            <div className="inspiration-card">
                 <InspirationSlider
                    currentInspiration={ currentInspiration  }
                    receptionImages={ receptionArray }
                    ceremonyImages={ ceremonyArray }
                    hashListener
                    hashInspirationName={hashInspirationName}
                />
                <div className="wedding-stage">
                    <a className="reception option active" onClick={ this._imagesSetBarAnimation(true) } href={`#${hashInspirationName}-reception`}>Reception</a>
                    <span className="bar">|</span>
                    <a className="ceremony option" onClick={ this._imagesSetBarAnimation(false) } href={`#${hashInspirationName}-ceremony`}>Ceremony</a>
                </div>
                <div className="copy container-fluid">
                    <h2 className="inspired-by"><small>inspired by</small> {images.inspiredBy}</h2>
                    <div className="inspiration-divider" />
                    <strong className="title">{ name } inspiration</strong>
                    <span className="desc-copy">{ description }</span>
                    <div className="row buttons txt-center">
                        <a className="col-xs-12 col-sm-4 btn-action" href={`/en/weddings/ideas/look-book/?inspirationId=${inspirationId}`}>Look Book</a>
                        <a className="col-xs-12 col-sm-4 btn-action" href={`/en/weddings/ideas/collection-details/?inspirationId=${inspirationId}`}>View Items</a>
                    </div>
                </div>
            </div>
        );
    }
}

